
document.addEventListener("DOMContentLoaded", () => {
  const autoPartSearchDiv = document.querySelector(".auto-part-search-bar");
  if (!autoPartSearchDiv) return; // Safety check

  // Create a MutationObserver that will fire whenever child elements change
  const observer = new MutationObserver((mutationsList, obs) => {
    // 1. Check if .gvwizard exists and has content
    const wizard = autoPartSearchDiv.querySelector(".gvwizard");
    if (!wizard || wizard.innerHTML.trim() === "") {
      return; // Not ready yet, keep observing
    }

    // 2. Check if there's a <select> that is *not* inside #gv-modal
    const selectsOutsideModal = autoPartSearchDiv.querySelectorAll(
      "select:not(#gv-modal *)"
    );

    if (selectsOutsideModal.length > 0) {
      // We found at least one <select> outside #gv-modal + .gvwizard is non-empty.
      // => Run your button creation code:

      const button = document.createElement("button");
      button.id = "apsToggleButton";
      button.textContent = "FIND YOUR VEHICLE";
      button.classList.add("button");

      // Insert the button before the .auto-part-search-bar
      autoPartSearchDiv.parentNode.insertBefore(button, autoPartSearchDiv);

      // Add click toggling
      button.addEventListener("click", function () {
        autoPartSearchDiv.classList.toggle("open-mmy");
      });

      console.log('Stop observing further changes (run only once)');
      // Stop observing further changes (run only once)
      observer.disconnect();
    }
  });

  // Start observing .auto-part-search-bar for subtree/child changes
  observer.observe(autoPartSearchDiv, {
    childList: true,
    subtree: true
  });



});
